import React from 'react';
import AdForm from './AdForm';
import { useQuery } from '@apollo/client/react';
import { CAMPAIGN_TYPES } from 'lib/graphql/queries/campaign';
import type { CampaignInfoStepProps } from 'organisms/CampaignSteps/CampaignInfoStep';
import Typography from '@mui/material/Typography';

type AdFormWithDataProps = CampaignInfoStepProps & {
  stickyActionsFooter?: boolean;
};

const AdFormWithData = (props: AdFormWithDataProps) => {
  const { data, loading, networkStatus, error } = useQuery<any>(CAMPAIGN_TYPES, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  const campaignTypes = data && data.campaignTypes ? data.campaignTypes : [];
  const isLoading = loading || networkStatus === 4;

  if (isLoading) return null;
  else if (error) return <Typography>Error loading campaign types...</Typography>;
  else {
    return <AdForm {...props} campaignTypes={campaignTypes} />;
  }
};

export default AdFormWithData;
